import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./size-info.module.scss";
import image from "../../../assets/images/size-info/tee.png";

function Tee() {
  return (
    <Grid container className={styles.sizeInfo}>
      <Grid item xs={12}>
        <h2 className={styles.sizeInfoTitle}>
          Используя вашу самую удобную футболку/майку/толстовку:
        </h2>
      </Grid>
      <Grid item xs={12} md={4} className={styles.sizeInfoImage}>
        <img src={image} />
      </Grid>
      <Grid item xs={12} md={8}>
        <ol>
          <li>Измерьте ширину от подмышки (проймы) до подмышки (в см)</li>
          <li>Измерьте ширину от плеча до плеча (в см)</li>
          <li>Измерьте длину от верхней точки плеча до низа (в см)</li>
          <li>
            Используйте размер из таблицы наиболее подходящий вашим меркам
          </li>
        </ol>
      </Grid>
    </Grid>
  );
}

Tee.propTypes = {};

export default Tee;
